'use client'

import { useEffect } from 'react'

export default function HashScrollHandler(): null {
  useEffect(() => {
    // Handle hash navigation on page load
    const handleHashScroll = (): void => {
      const hash = window.location.hash.replace('#', '')
      const scrollToSection = sessionStorage.getItem('scrollToSection')

      // Use sessionStorage value if available, otherwise use hash
      const targetId = scrollToSection || hash

      if (targetId) {
        // Clear sessionStorage
        sessionStorage.removeItem('scrollToSection')

        // Small delay to ensure DOM is ready
        setTimeout(() => {
          const element = document.getElementById(targetId)
          if (element) {
            // Jump directly without smooth scrolling to avoid flash
            window.scrollTo({
              top: element.offsetTop - 100, // Offset for header
              behavior: 'auto',
            })
          }
        }, 0)
      }
    }

    // Run immediately and also on hash change
    handleHashScroll()
    window.addEventListener('hashchange', handleHashScroll)

    return (): void => {
      window.removeEventListener('hashchange', handleHashScroll)
    }
  }, [])

  return null
}
